/* eslint-disable no-undef */
/* eslint-disable quote-props */
/* eslint-disable max-len */
import React from 'react';
import { Typography, Row, Col, Icon } from 'antd';

const { Text } = Typography;

const About = () => {
	gtag('config', 'UA-125808362-1', {
		'page_title': 'about',
		'page_path': '/about'
	});
	return (
		<div className="about">
			<Row>
				<Col xs={1} sm={1} lg={4} />
				<Col xs={22} sm={22} lg={16}>
					<h1>
						Optimized images = faster websites. Better user experience.
					</h1>
					<Text>
						We believe, every image on the internet should be compressed efficiently but not at the cost of quality.
						<br /><br />
						At imagecompressor.io we bring you best image compression techniques available today.
					</Text>
					<br /><br />
					<h2>Behind the scenes</h2>
					<Text>
						Google recommendeds - run your JPEGs through MozJPEG (q=80 or lower is fine for web content) and consider Progressive JPEG support, PNGs through pngquant and SVGs through SVGO.
					</Text>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/automating-image-optimization">
							&nbsp;(Source)&nbsp;
					</a>
					<br /><br />
					<Text>
						<Text strong>JPEG/JPG</Text> files are compressed using <Text code>MozJPEG</Text> (Mozilla JPEG Encoder Project).&nbsp;
						<Text strong>PNG</Text> files are compressed using <Text code>pngquant</Text> & <Text code>ECT</Text>.
					</Text>
					<br /><br />
					<Text>Progressive & lossless compression would be added soon.</Text>
					<br /><br />
					<Text>Would love some feedback or comments. Made by Aseem Gautam &nbsp;(
						<Text><a href="mailto:aseem.gautam@gmail.com"><Icon type="mail" /></a></Text>,&nbsp;
						<Text><a href="https://www.linkedin.com/in/aseemgautam/"><Icon type="linkedin" /></a></Text>,&nbsp;
						<Text><a href="https://github.com/aseemgautam"><Icon type="github" /></a></Text>)
					</Text>
				</Col>
				<Col xs={1} sm={1} lg={4} />
			</Row>
		</div>
	);
};

export default About;



// WEBPACK FOOTER //
// ./src/About.js